import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';


import { HttpClient } from '@angular/common/http';

import { anyU } from 'src/app/models/anyU';
import { environment } from 'src/environments/environment';
import { webName } from 'src/app/models/webName';
declare var bootstrap: any;


@Component({
  selector: 'app-web-name',
  templateUrl: './web-name.component.html',
  styleUrls: ['./web-name.component.css']
})
export class WebNameComponent  implements OnInit {

 baseUrl = environment.apiBaseUrl;
  @ViewChild('userModal') userModal: ElementRef | undefined;

  searchTerm: string = '';
  filteredList: any[] = []; // لیستی برای نمایش نتایج جستجو (یا لیست اصلی اگر جستجو فعال نباشد)
  anyList: any[] = [];

  anyObj: any ={  // آبجکت برای فرم modal
      "id":0,
      "wbeAddress":"",
      "text":"",
  }
  http = inject(HttpClient);

   ngOnInit(): void {
  this.getAllwebsite();
  }

  // constructor(private userService: Service) {}

  openModal(): void {
  // console.log("openModal triggered");
  if (this.userModal) {
    const modal = new bootstrap.Modal(this.userModal.nativeElement);
    modal.show();
  } else {
    // console.warn("userModal is undefined!");
  }
}


closeModal(): void {
  if (this.userModal) {
    const modal = bootstrap.Modal.getInstance(this.userModal.nativeElement);
    if (modal) modal.hide();
  }
}

  getAllwebsite(): void {

    this.http.get<webName[]>(`${this.baseUrl}/websites`).subscribe((res) => {
      // this.anyList = res;
       this.anyList = res.reverse(); 
      // console.log(this.anyList); // چاپ داده‌ها برای بررسی
      this.filteredList = res; // در ابتدا، لیست فیلتر شده همان لیست کامل است

    });
  }



  // تابع جستجو
  searchWebsites(): void {
      if (this.searchTerm.trim() === '') {
          // اگر عبارت جستجو خالی بود، لیست اصلی را نمایش بده
          this.filteredList = this.anyList;
      } else {
          // اگر عبارت جستجو داشت، درخواست جستجو را به سرور بفرست
          this.http.get<webName[]>(`${this.baseUrl}/websites/search?query=${encodeURIComponent(this.searchTerm)}`).subscribe((res) => {
              this.filteredList = res;
          }, (error) => {
              console.error("Search error:", error);
              // در صورت خطا، می‌توانیم لیست را خالی کنیم یا لیست اصلی را نگه داریم
              this.filteredList = []; // یا this.filteredList = this.anyList;
          });
      }
  }
   // تابعی که هنگام تغییر عبارت جستجو فراخوانی می‌شود (مثلاً با استفاده از (input) در HTML)
  onSearchInput(): void {
      this.searchWebsites();
  }

  onSave1(): void {
    // console.log("Sending anyObj:", this.anyObj);
    this.http.post<anyU>(`${this.baseUrl}/websites`, this.anyObj).subscribe({
      next: (res) => {
        this.getAllwebsite();
        this.closeModal();
      },
      error: (err) => {
        console.error("Error details:", err);
      }
  });
  }

  onSave(): void {
  if (this.anyObj.id === 0) {
    // افزودن
    const newUser = { ...this.anyObj };
    delete newUser.id; // ← ID را حذف کن که نره به سرور

    this.http.post<webName>(`${this.baseUrl}/websites`, newUser).subscribe((res) => {
      this.getAllwebsite();
      this.closeModal();
    });
  } else {
    // ویرایش
    // this.http.put<anyU>(`${this.baseUrl}/mythings/${this.anyObj.id}`, this.anyObj).subscribe((res) => {

    this.http.post<webName>(`${this.baseUrl}/websites/update`, this.anyObj).subscribe((res) => {
      this.getAllwebsite();
      this.closeModal();
    });
  }
}


  // باز کردن مدال برای ویرایش
  openEditModal(user: any): void {
    this.anyObj = { ...user }; // پر کردن فیلدها با داده‌های کاربر انتخاب‌شده
    this.openModal();
  }

  // حذف کاربر
  delete(Id: number): void {
    if (confirm("آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟")) {
      // this.http.delete(`${this.baseUrl}/mythings/${Id}`).subscribe(() => {
        // this.http.post(`${this.baseUrl}/mythings/delete`, Id).subscribe(() => {
        this.http.post(`${this.baseUrl}/websites/delete/${Id}`, null).subscribe(() => {

        this.getAllwebsite(); // بعد از حذف، لیست کاربران را مجدد بگیر
      });
    }
  }

  fixUrl(url: string): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return 'http://' + url;
}


}


